export default {"src":"https://marketing-edge-assets.lemonade.com/_next/static/media/car.1a6229a6.svg","height":1393,"width":3480,"blurWidth":0,"blurHeight":0};